
const digest = 'b85565345d1681e8f7d70ba67a82863cc6cb481862250e4fc42cab86d4e66fa7';
const classes = {"scrollContainer":"_scrollContainer_6gyky_1","wrapper":"_wrapper_6gyky_5","item":"_item_6gyky_13","active":"_active_6gyky_28","input":"_input_6gyky_33","itemContent":"_itemContent_6gyky_40","footer":"_footer_6gyky_45"};
const css = `._scrollContainer_6gyky_1 {
  max-height: calc(100vh - 300px);
}

._wrapper_6gyky_5 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #fbfbfd;
  padding: 24px;
}

._item_6gyky_13 {
  background: #ffffff;
  border-radius: 15px;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #ffffff;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}
._item_6gyky_13._active_6gyky_28 {
  border: 1px solid rgba(0, 84, 188, 0.2);
  background-color: #f3f5ff;
}

._input_6gyky_33 {
  flex-shrink: 0;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

._itemContent_6gyky_40 {
  flex: 1;
  min-width: 0;
}

._footer_6gyky_45 {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #eaedf3;
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  